// Vendors
import $ from 'jquery';
import { AJAX_URL } from './config';
const merchantButton = $('.merchant-sso');

if (merchantButton.length) {
  merchantButton.on('click', (event) => {
    event.preventDefault();
    $.ajax({
      url: `${AJAX_URL}wl_merchant_sso`,
      method: 'POST',
      dataType: 'json',
      success: (res) => {
        if ($(window).width() < 960) {
          window.open(res.data.url, '_self');
        } else {
          window.open(res.data.url, '_blank');
        }
      }
    });
  });
}
